import(/* webpackMode: "eager" */ "/home/runner/work/trovanorma-landing/trovanorma-landing/src/app/page.tsx");
